module.exports = "/resources/assets/prod/4f140b92215c8ad4e32a624e75686ef7.svg";